/* eslint-disable no-magic-numbers */
import Vue from 'vue';

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        dialogHeaderEl.style.cursor = 'move';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft;
            const disY = e.clientY - dialogHeaderEl.offsetTop;

            // 获取到的值带px 正则匹配替换
            let styL, styT;

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if (sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
            } else {
                styL = +sty.left.replace(/\px/g, '');
                styT = +sty.top.replace(/\px/g, '');
            }

            document.onmousemove = function(e) {
                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX;
                const t = e.clientY - disY;

                // 移动当前元素
                dragDom.style.left = `${l + styL}px`;
                dragDom.style.top = `${t + styT}px`;

                // 将此时的位置传出去
                // binding.value({x:e.pageX,y:e.pageY})
            };

            document.onmouseup = function(e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };
    }
});

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
    bind(el, binding, vnode, oldVnode) {
        const dragDom = binding.value.$el.querySelector('.el-dialog');

        el.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - el.offsetLeft;

            document.onmousemove = function(e) {
                e.preventDefault(); // 移动时禁用默认事件

                // 通过事件委托，计算移动的距离
                const l = e.clientX - disX;
                dragDom.style.width = `${l}px`;
            };

            document.onmouseup = function(e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };
    }
});

// 自定义指令限制输入框只能输入两位小数的正数
Vue.directive('input-limit', {
    bind(el, binding) {
        var wins0 = /[^\d]/g; // 整数判断
        var wins1 = /[^\d^\.]/g; // 小数判断
        var flag = true;
        var points = 0;
        var lengths = 0;
        var remainder = 0;
        var noInt = 0;
        const target = el instanceof HTMLInputElement ? el : el.querySelector('input');
        target.addEventListener('compositionstart', e => {
            flag = false;
        });
        target.addEventListener('compositionend', e => {
            flag = true;
        });
        target.addEventListener('input', e => {
            setTimeout(function () {
                if (flag) {
                    if (binding.value === 0) {
                        if (wins0.test(e.target.value)) {
                            e.target.value = e.target.value.replace(wins0, '');
                            e.target.dispatchEvent(new Event('input')); // 手动更新v-model值
                        };
                    };
                    if (binding.value === 1) {
                        if (wins0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) remainder = true;
                        if ((e.target.value.split('.')).length - 1 > 1) points = true;
                        if (e.target.value.toString().split('.')[1] !== undefined) if (e.target.value.toString().split('.')[1].length > 1) lengths = true;
                        if (e.target.value.toString().indexOf('.') !== -1) {
                            noInt = false;
                        } else {
                            noInt = true;
                        };
                        if (wins1.test(e.target.value) || lengths || points || remainder) {
                            if (!noInt) {
                                e.target.value = e.target.value.replace(wins1, '').replace('.', '$#$').replace(/\./g, '').replace(
                                    '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                                    '.') + 2);
                            } else {
                                e.target.value = e.target.value.replace(wins0, '');
                            };
                            e.target.dispatchEvent(new Event('input'));
                        };
                    };
                    if (binding.value === 2) {
                        if (wins0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) remainder = true;
                        if ((e.target.value.split('.')).length - 1 > 1) points = true;
                        if (e.target.value.toString().split('.')[1] !== undefined) {
                            if (e.target.value.toString().split('.')[1].length > 2) lengths = true;
                        };
                        if (e.target.value.toString().indexOf('.') !== -1) {
                            noInt = false;
                        } else {
                            noInt = true;
                        };
                        if (wins1.test(e.target.value) || lengths || points || remainder) {
                            if (!noInt) {
                                e.target.value = e.target.value.replace(wins1, '').replace('.', '$#$').replace(/\./g, '').replace(
                                    '$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(
                                    '.') + 3);
                            } else {
                                e.target.value = e.target.value.replace(wins0, '');
                            }
                            e.target.dispatchEvent(new Event('input'));
                        };
                    };
                };
            }, 0);
        });
    }
});
